// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__2geyk","wrapper":"Empty_wrapper__dvS4N","title":"Empty_title__n0Z_W","desc":"Empty_desc__jPIlu","button":"Empty_button__zVN7m"};